module.exports = __webpack_public_path__ + "media/images/illustrations/shape-1-e7c6d73f68fe6e2e1c2c56de81c39547.png";